import usePreference from "./usePreference";

export default function useMainLayoutPreference() {
  return usePreference({
    id: "main-layout",
    options: ["Map", "Cards"],
    defaultOption: "Cards",
  });
}
